import * as types from '../types.js';

export default {

	html: `
		<style>
			#sm-lot-meta #lot_number { width: 14rem; }
			#sm-lot-meta #manufacture_date, #sm-lot-meta #expiration_date { width: 10rem; }
			#sm-lot-meta #program_id { width: 18rem; }
		</style>
		<form id="sm-lot-meta" class="form" autocomplete="off">
			<div class="title">Lote / datas / programa</div>
			<p id="sm-lot-hint" class="mts muted" style="max-width:40rem"></p>
			<div class="fsb mtl">
				<label>Lote fab.
					<input id="lot_number" type="text" placeholder="Deixe em branco para não alterar">
				</label>
				<label>Fabricação
					<input id="manufacture_date" type="text" placeholder="aaaa-mm-dd">
				</label>
				<label>Validade
					<input id="expiration_date" type="text" placeholder="aaaa-mm-dd">
				</label>
				<label>Programa
					<input id="program_id" type="text" list="programs_list" placeholder="ID ou lista">
				</label>
			</div>
			<datalist id="programs_list"></datalist>
			<div class="fsb mtm">
				<span></span>
				<span>
					<button type="button" class='bn_Escape button'>Fechar</button>
					<button type="button" class='bn_Enter button'>Aplicar</button>
				</span>
			</div>
		</form>
	`,

	form: {
		selector: '#sm-lot-meta',
		init(formset) {
			formset.form.eraseValues();
			formset.loadList('#programs_list', 'programs', { labels: [ 'name' ], value: 'id' });
			Object.getPrototypeOf(this).init.call(this);
		},
	},

	fields: [
		{ properties: { selector: '#lot_number' }, types: [ types.name() ] },
		{ properties: { selector: '#manufacture_date' }, types: [ types.date() ] },
		{ properties: { selector: '#expiration_date' }, types: [ types.date() ] },
		{ properties: { selector: '#program_id' }, types: [ types.datalist() ] },
	],
};
